module.exports = __webpack_public_path__ + "static/erp-slider2-f28cccce7aa78b4eb6d19b772d5665d1.jpeg";